
export default [
    {
        path: '/',
        name: 'auth.login',
        components: {
            authenticated: () => import(/* webpackChunkName: "auth-redirect" */ './../views/Auth/Redirect.vue'),
            unauthenticated: () => import(/* webpackChunkName: "auth-login" */ './../views/Auth/Login.vue')
        },
        meta: {
            auth: false
        }
    },
    {
        path: '/logout',
        name: 'auth.logout',
        components: {
            authenticated: () => import(/* webpackChunkName: "auth-logout" */ './../views/Auth/Logout.vue'),
            unauthenticated: () => import(/* webpackChunkName: "auth-logout" */ './../views/Auth/Logout.vue')
        },
        meta: {
            auth: false
        }
    },
    {
        path: '/token/:token',
        name: 'auth.token',
        components: {
            authenticated: () => import(/* webpackChunkName: "auth-token" */ './../views/Auth/Token.vue'),
            unauthenticated: () => import(/* webpackChunkName: "auth-token" */ './../views/Auth/Token.vue')
        },
        meta: {
            auth: false
        }
    }
]
